import { render, staticRenderFns } from "./NumberDetailModal.vue?vue&type=template&id=e5a3d790&scoped=true"
import script from "./NumberDetailModal.vue?vue&type=script&lang=js"
export * from "./NumberDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a3d790",
  null
  
)

export default component.exports